/* eslint-disable no-unused-vars */
/* eslint-disable one-var */
/* eslint-disable no-var */
/* eslint-disable one-var-declaration-per-line */
/* eslint-disable func-names */
// App
import Vue from 'vue';
import VueMask from 'v-mask';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import 'floating-vue/dist/style.css';
import VueCookies from 'vue-cookies';
import VueShepherd from 'vue-shepherd';
import VueGtm, { useGtm } from '@gtm-support/vue2-gtm';
import FloatingVue from 'floating-vue';

import { Swiper as SwiperClass, Pagination } from 'swiper/core';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
import VBodyScrollLock from 'v-body-scroll-lock';
import App from './App.vue';
import router from './routes';
import store from './store';
import i18n from './i18n';
import { api } from './helpers/api';

// Plugins
import '@/assets/styles/main.css';
import Flickity from "vue-flickity"; // eslint-disable-line
import 'swiper/swiper-bundle.css';

library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('flickity', Flickity);
moment.locale('pl');
const toastOptions = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  toastClassName: 'esc-toast',
  position: POSITION.BOTTOM_CENTER,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  hideProgressBar: true,
  draggable: false,
  icon: false,
  closeButton: false,
};

Vue.use(Toast, toastOptions);
Vue.use(VueCookies);
Vue.use(VueShepherd);
Vue.use(VBodyScrollLock);
Vue.use(FloatingVue, {
  themes: {
    es: {
      triggers: ['click', 'hover', 'touch'],
      autoHide: true,
      placement: 'top',
    },
  },
});
Vue.use(VueMask);
SwiperClass.use([Pagination]);
Vue.use(getAwesomeSwiper(SwiperClass));
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  defer: true,
  enabled: true,
});
Vue.config.productionTip = false;

window.Event = new Vue();

api.interceptors.request.use((config) => {
  if (store.getters['auth/isLogged']) {
    // eslint-disable-next-line
    config.headers.common["X-AUTH-TOKEN"] = `${store.state.auth.authToken}`;
    return config;
  }
  return config;
});

api.interceptors.response.use(null, (error) => {
  if (error.response) {
    if (error?.response?.status === 403) {
      store.commit('auth/clearAuth');
      if (router.currentRoute.name !== 'Auth.Login') {
        router.push({
          name: 'Auth.Login',
          params: {
            alert: {
              type: 'warning',
              text: i18n.t('auth.token_expired'),
            },
          },
        });
      }
      store.commit('layout/finishLoading');
    }
  }
  return Promise.reject(error);
});

Vue.mixin({
  data() {
    return {
      REGULATIONS_PATH: '/Regulamin_2026.pdf?v=2026_09',
    };
  },
  methods: {
    gtmPush: ({ eventName, eventPage, eventValue }) => {
      const gtm = useGtm();
      if (gtm.enabled()) {
        gtm.trackEvent({
          event: eventName,
          event_page: eventPage,
          event_value: eventValue,
        });
      }
    },
    async routerPush(param) {
      const currentPathName = router.currentRoute.name;
      const newPathName = param?.name;
      if (currentPathName !== newPathName) return router.push(param);
      return Promise.reject();
    },
  },
});

new Vue({
  router,
  store,
  i18n,
  created() {
    return (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/pl_PL/sdk/xfbml.customerchat.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },
  render: h => h(App),
}).$mount('#app');
